import React from 'react';
import { IWebhook } from '../../models/Webhooks';
import { ColumnGenerator } from '../../logic/Columns/ColumnGenerator';
import { IColumn, Icon, IconButton, SelectionMode, ShimmeredDetailsList } from '@fluentui/react';
import Header from '../Common/Header';

interface IWebhooksTableProps {
    webhooks?: IWebhook[];
    isLoading: boolean;
    onEdit: (webhook: IWebhook) => void;
    onDelete: (webhook: IWebhook) => void;
}

const WebhooksTable: React.FC<IWebhooksTableProps> = (props) => {

    if (!props.isLoading && (!props.webhooks || props.webhooks.length === 0))
    return (<div className='main-content' style={{marginTop: '10em'}}>
        <Header size='h3' icon='Info' showIconCircle={false}>
            No webhooks have been created yet
        </Header>
    </div>)


    // Edit leads the row and delete closes it, rather than sitting together in one Actions column.
    // Edit is the action for the row you are reading, so it belongs where the eye starts; keeping
    // delete at the far end means the destructive one is never where the common one used to be.
    // House style for the leading edit button (see the root CLAUDE.md).
    //
    // Both are bare icon buttons, matching the row actions everywhere else (contacts, product lines,
    // linked items), and both are titled -- an icon-only button is otherwise announced, and hovered,
    // as nothing at all. Distinct `field` values because ColumnGenerator keys off it.
    const columns: IColumn[] = [
        ColumnGenerator('', 'edit', 40, 40, (w) =>
            <IconButton iconProps={{iconName: 'Edit'}} title='Edit webhook' ariaLabel='Edit webhook' onClick={() => props.onEdit(w)} />),
        ColumnGenerator('Name', 'name', 100),
        ColumnGenerator('Global Enabled', 'globalEnabled', 100, 100, (w) => w.globalEnabled ? <Icon style={{fontSize: '2em', textAlign: 'center'}} iconName='Checkmark' /> : <></>),
        ColumnGenerator('', 'delete', 40, 40, (w) =>
            <IconButton iconProps={{iconName: 'Delete'}} title='Delete webhook' ariaLabel='Delete webhook' onClick={() => props.onDelete(w)} />)
    ]

    return (
        <ShimmeredDetailsList
            items={props.webhooks ?? []}
            setKey="webhooksList"
            enableShimmer={props.isLoading}
            selectionMode={SelectionMode.none}
            columns={columns}
        />
    )
}

export default WebhooksTable;
